import Swal from "sweetalert2/src/sweetalert2";
import  './index.css';
import { icon } from "@fortawesome/fontawesome-svg-core";

const errorToast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: false,
	icon:'error',
	color: "#fff",
	background: 'var(--dommus-color-red)',
	customClass: {content: 'alert-toast', icon:'alert-toast'},

	onOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
	}
});

const successToast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: false,
	icon:'success',
	color: "#fff",
	background: 'var(--dommus-color-green)',
	customClass: {content: 'alert-toast', icon:'alert-toast'},
	onOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
	}
});

const infoToast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: false,
	icon:'info',
	background: 'var(--dommus-color-secondary-light)',
	color: "#fff",
	customClass: {content: 'alert-toast', icon:'alert-toast'},
	onOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
	}
});

const warningToast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: false,
	icon:'warning',
	background: 'var(--dommus-color-2)',
	color: "#fff",
	customClass: {content: 'alert-toast', icon:'alert-toast'},
	onOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
	}
});

const loadingToast = Swal.mixin({
	toast: true,
	position: 'bottom-end',
	showConfirmButton: false,
	allowOutsideClick: false,
	allowEscapeKey: false,
    icon: 'info',
	background: 'var(--dommus-color)',
	color: "#fff",
	customClass: {content: 'alert-toast', icon:'alert-toast'},
	didOpen: () => {
		Swal.showLoading()
	}
});


export {
	errorToast,
	successToast,
	infoToast,
	warningToast,
	loadingToast
};
